import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ErrorBoundary } from 'shared/src/components';
import App from './App';
import Container from './components/Container';
import pollworkerStore from './state/store';
import 'shared/src/index.css';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import * as Sentry from 'shared/src/setupSentry';

if (!import.meta.env.DEV) Sentry.initialSetup('pollworker');

dayjs.extend(LocalizedFormat);
dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(customParseFormat);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={pollworkerStore}>
    <ErrorBoundary>
      <Container>
        <App />
      </Container>
    </ErrorBoundary>
  </Provider>,
);
